"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutTableWithSearchAndToggle = void 0;
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var styled_components_1 = __importDefault(require("styled-components"));
var utils_1 = require("../utils");
var p = utils_1.createPrefixer("wh-Layouts-LayoutTableWithSearchAndToggle");
var classes = {
    top: p(templateObject_1 || (templateObject_1 = __makeTemplateObject(["top"], ["top"]))),
};
var Wrapper = styled_components_1.default(antd_1.Row)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  & {\n    .", " {\n      padding: 0 1rem;\n    }\n  }\n"], ["\n  & {\n    .", " {\n      padding: 0 1rem;\n    }\n  }\n"])), classes.top);
var LayoutTableWithSearchAndToggle = function (_a) {
    var search = _a.search, table = _a.table, toggle = _a.toggle;
    return (react_1.default.createElement(Wrapper, { gutter: [0, 16] },
        react_1.default.createElement(antd_1.Col, { xs: 24 },
            react_1.default.createElement(antd_1.Row, { className: classes.top },
                react_1.default.createElement(antd_1.Col, { flex: "auto" }, search),
                react_1.default.createElement(antd_1.Col, { flex: "none" }, toggle))),
        react_1.default.createElement(antd_1.Col, { xs: 24 }, table)));
};
exports.LayoutTableWithSearchAndToggle = LayoutTableWithSearchAndToggle;
LayoutTableWithSearchAndToggle.classes = classes;
var templateObject_1, templateObject_2;
